"use client";

import type { ReactNode } from "react";
import { Toaster } from "sonner";

import { QueryProvider } from "./query-provider";
import { ThemeProvider } from "./theme-provider";

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ThemeProvider>
      <QueryProvider>
        {children}
        <Toaster 
          position="bottom-right" 
          expand={false} 
          richColors 
          closeButton 
          duration={4000}
        />
      </QueryProvider>
    </ThemeProvider>
  );
}
